export const PRODUCT = {
    OESTRA_CREAM: "oestra-cream",
    FACE_CREAM: "face-cream",
    FACE_CREAM_FINASTERIDE: "face-cream-finasteride",
    DOSAGE_ADJUSTMENT: "dosage-adjustment",
    OESTRA_ENDO_PRE_PURCHASE: "endometriosis",
    OESTRA_POSTPARTUM_PRE_PURCHASE: "postpartum",
    LIBIDA: "libida",
    NAD: "nad",
} as const;

/** Checkout query param that seeds the cart: `?products=slug:priceId,slug2:priceId2`. */
export const CART_PRODUCTS_QUERY_PARAM = "products";

export const PRODUCT_TITLES = {
    OESTRA_CREAM: "Oestra®",
    FACE_CREAM: "BodyMatched®",
    LIBIDA: "Libida®",
    NAD: "NAD+",
} as const;

const PRODUCT_TITLES_BY_SLUG: Record<string, string> = {
    [PRODUCT.OESTRA_CREAM]: PRODUCT_TITLES.OESTRA_CREAM,
    [PRODUCT.FACE_CREAM]: PRODUCT_TITLES.FACE_CREAM,
    [PRODUCT.FACE_CREAM_FINASTERIDE]: PRODUCT_TITLES.FACE_CREAM,
    [PRODUCT.LIBIDA]: PRODUCT_TITLES.LIBIDA,
    [PRODUCT.NAD]: PRODUCT_TITLES.NAD,
};

export const getProductTitle = (
    productSlug: string | undefined,
    fallbackTitle: string
): string => productSlug
    ? PRODUCT_TITLES_BY_SLUG[productSlug] ?? fallbackTitle
    : fallbackTitle;